<template>
  <div>
    <b-modal
      id="modal-edit-group-user-role"
      ref="modal-edit-group-user-role"
      footer-class="flex-nowrap"
      no-close-on-backdrop
      no-close-on-esc
      centered
    >
      <template #modal-header>
        <h3>{{ $t('modals.editUser.title') }}</h3>
      </template>

      <template #default>
        <div class="mx-5 mb-4" v-if="groupRoles.length || isSysAdmin">
          <div class="mt-3 text-center">
            <p><strong>
              {{ $t('modals.editUser.name') }}: {{ userObject.name || '-----' }}<br>
              {{ $t('modals.editUser.email') }}: {{ userObject.email }}
            </strong></p>
          </div>
          <b-dropdown
            id="setRole"
            menu-class="w-100 pb-2"
            block
            :text="dropdownText"
            v-model="role"
          >
            <div class="w-100" v-for="(r, index) in groupRoles" :key="index">
              <b-dropdown-item-button  @click="setRole(r)">
                {{ r.name }}</b-dropdown-item-button>
              <b-dropdown-text>
                {{ $t(`roles.${r.handle}`) }}</b-dropdown-text>
              <b-dropdown-divider
                v-if="index !== groupRoles.length-1">
              </b-dropdown-divider>
            </div>
          </b-dropdown>
        </div>
      </template>

      <template #modal-footer>
        <b-button
          class="p-3 border-right-light-grey"
          block
          @click="cancelModal"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button

          variant="primary"
          class="p-3"
          block
          @click="editUser"
        >
          {{ $t('modals.editUser.validate') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AddGroupMember from '@/graphQlQueries/mutations/addGroupMember';
import GetGroupRoles from '@/graphQlQueries/queries/getGroupRoles';

export default {
  name: 'ModalEditUserRole',
  props: [
    'groupId',
    'userObject',
    'currentUserRole',
    'isSysAdmin',
  ],
  data() {
    return {
      dropdownText: null,
      groupRoles: [],
      role: null,
    };
  },
  mounted() {
    this.role = this.userObject.role;
    this.dropdownText = this.role.name;
    this.$refs['modal-edit-group-user-role'].show();
  },
  apollo: {
    groupRoles: {
      query: GetGroupRoles,
      update(data) {
        const roles = [];
        data.roles.forEach((item) => {
          // make sure that a user don't change the role uppermore than his role
          // todo: has to be done nice an generic
          if (this.currentUserRole !== 'manager') {
            if (item.handle !== 'accountManager') {
              const element = {
                role_id: item.role_id,
                name: item.name,
                handle: item.handle,
                description: item.description,
              };
              roles.push(element);
            }
          }
        });
        // sort the roles by role_id
        roles.sort((a, b) => {
          if (a.role_id < b.role_id) {
            return -1;
          }
          if (a.role_id > b.role_id) {
            return 1;
          }
          return 0;
        });
        return roles;
      },
      fetchPolicy: 'network-only',
    },
  },
  methods: {
    updateFields(key, value) {
      this[key] = value;
    },
    async editUser() {
      try {
        await this.$apollo.mutate({
          mutation: AddGroupMember,
          variables: {
            obj: {
              user_id: this.userObject.userId,
              role_id: this.role.role_id,
              group_id: this.groupId,
            },
          },
        });
      } catch (ex) {
        console.error(ex);
      }
      this.name = null;
      this.role = null;
      this.$emit('editUser');
    },
    setRole(value) {
      this.dropdownText = value.name;
      this.role = value;
    },
    cancelModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style scoped>

</style>
